import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AuthorizationService } from '../../../services/authorization.service';
import { ActivatedRoute } from "@angular/router";
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { EntitlementService } from '../../../services/ems.service';
import { TimeLimitedEntitlementData } from '../../../types/TimeLimitedEntitlementData';
import { SplashService } from 'src/app/modules/services/splash.service';
import { CellpopupComponent } from 'src/app/modules/shared-components/cellpopup/cellpopup.component';
import { MatDialog } from '@angular/material/dialog';
import { SnackService } from 'src/app/modules/services/snack.service';
import { ColumnData, UpdateColumnResponse } from 'src/app/modules/types/ColumnData';
import { Observable, forkJoin } from 'rxjs';
import { ColumnManagerService, ColumnSaveConfig } from 'src/app/modules/services/column-manager.service';

@Component({
    selector: 'app-admin-timelimitedentitlements-view',
    templateUrl: './admin-timelimitedentitlements-view.component.html',
    styleUrls: [
        '../../../shared-styles/divs.scss',
        '../../../shared-styles/tables.scss',
        '../../../shared-styles/elements.scss',
        './admin-timelimitedentitlements-view.component.scss'
    ],
    standalone: false,
    providers: [ColumnManagerService]
})
export class AdminTimelimitedentitlementsViewComponent implements OnInit, AfterViewInit {
  isLoading = true;
  user: string;
  entitlements: TimeLimitedEntitlementData[] = new Array<TimeLimitedEntitlementData>();
  accountname: string;
  dataSource: MatTableDataSource<TimeLimitedEntitlementData> = new MatTableDataSource<TimeLimitedEntitlementData>();
  filter: string | null = null;
  LOADDURATION = 8;
  hasData = true;
  filterString = "";
  pageSize = 0;
  totalEntitlements = 0;

  private saveConfig: ColumnSaveConfig = {
    tableName: 'admin-timelimited',
    saveMethod: (req) => this.ems.saveTimeLimitedColumns(req)
  };

  @ViewChild(MatPaginator, { static: true }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort?: MatSort;

  constructor(
    private datePipe: DatePipe = new DatePipe('mediumDate'),
    private auth: AuthorizationService,
    private ems: EntitlementService,
    private splash: SplashService,
    private route: ActivatedRoute,
    public snackMsg: SnackService,
    public dialog: MatDialog,
    public columnManager: ColumnManagerService) {
    splash.show(this.LOADDURATION);
    this.user = this.route.snapshot.paramMap.get('username') ?? "";
    this.accountname = this.route.snapshot.paramMap.get('customer') ?? "";
    const getTimeLimitedEntitlements = this.ems.getTimeLimitedEntitlements();
    const getUserSettings = this.ems.getUserSettings(this.auth.getCRMID(), this.ems.userMode, "time-limited");
    const getQueries: Observable<any>[] = new Array<Observable<any>>();
    getQueries.push(getTimeLimitedEntitlements);
    getQueries.push(getUserSettings);

    forkJoin(getQueries).subscribe(next => {
      if (next == null) {
        this.splash.hide();
        return;
      }
      const data = next[0]
      const userResult:UpdateColumnResponse = next[1];
      this.columnManager.initColumns(userResult);
      this.entitlements = new Array<TimeLimitedEntitlementData>();

      for (const e in data) {
        const el = new TimeLimitedEntitlementData(data[e]);
        this.entitlements.push(el);
      }
      this.totalEntitlements = this.entitlements.length;
      this.dataSource = new MatTableDataSource(this.entitlements);
      this.dataSource.paginator = this.paginator ?? null;
      this.dataSource.sort = this.sort ?? null;
      splash.hide();
    }, () => {
      this.snackMsg.openSnackBar("An Error Has Occurred.", 5000);
      this.splash.hide();
    });
  };

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator ?? null;
      if (this.sort != undefined) this.sort.sortChange.subscribe(next => {
        if (this.paginator != null) this.paginator.pageIndex = 0;
      }, () => {
        this.snackMsg.openSnackBar("An Error Has Occurred.", 5000);
        this.splash.hide();
      });
    }
  }

  applyFilterEvent(filterEvent: Event) {
    if (filterEvent != null) this.applyFilter((filterEvent.target as HTMLInputElement).value);
  }

  applyFilter(newFilter?: string) {
    if (newFilter != null) {
      this.filterString = newFilter;
    }
    this.updateFilterPredicate(this.filterString, this.columnManager.columnData());
    this.hasData = this.dataSource.data.length > 0;
    if (this.paginator != null) this.dataSource.paginator = this.paginator;
    if (this.sort != null) this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  showDetail(datacolumn: string, input: string) {
    if (input != null && input.toString().trim() != "") {
      const dialogRef = this.dialog.open(CellpopupComponent, {
        data: {
          datavalue: input,
          datacolumn: datacolumn,
          url: ""
        },
        width: '35vw'
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  updateFilterPredicate(filter: string, column_data: ColumnData[]) {
    this.dataSource.filterPredicate = function (d: TimeLimitedEntitlementData, filter: string): boolean {
      let searchActivatedDate = true;
      let searchInternalComment = true;
      let searchAccountName = true;
      let searchProductName = true;
      let searchEndDate = true;
      let searchDays = true;
      let searchLicense = true;
      let searchFingerprint = true;
      let searchIPAddress = true;
      let searchLicenseType = true;

      function getVisibleByColumnId(columnid: string) {
        return column_data.filter(e => e.id == columnid).map(e => e.visible).pop();
      }

      if (column_data != null) {
        searchActivatedDate = getVisibleByColumnId("activateddate");
        searchInternalComment = getVisibleByColumnId("internalcomment");
        searchAccountName = getVisibleByColumnId("accountname");
        searchProductName = getVisibleByColumnId("productname");
        searchEndDate = getVisibleByColumnId("enddate");
        searchDays = getVisibleByColumnId("daystolive");
        searchLicense = getVisibleByColumnId("license");
        searchFingerprint = getVisibleByColumnId("fingerprint");
        searchIPAddress = getVisibleByColumnId("ipaddress");
        searchLicenseType = getVisibleByColumnId("timelimitedtype");
      }

      // ensure case insensitivity
      filter = filter.toLowerCase();

      const foundAccountName = searchAccountName && d.accountname != null && d.accountname.toLowerCase().trim().indexOf(filter) != -1;
      const foundProductName = searchProductName && d.productname != null && d.productname.toLowerCase().trim().indexOf(filter) != -1;
      const foundActivatedDate = searchActivatedDate && d.activateddate != null && d.activateddate != null && d.activateddate.toString().toLowerCase().indexOf(filter) != -1;
      const foundLicense = searchLicense && d.license != null && d.license.toLowerCase().trim().startsWith(filter);
      const foundFingerprint = searchFingerprint && d.fingerprint != null && d.fingerprint.toLowerCase().trim().indexOf(filter) != -1;
      const foundIPAddress = searchIPAddress && d.ipaddress != null && d.ipaddress.toLowerCase().trim().indexOf(filter) != -1;
      const foundInternalComment = searchInternalComment && d.internalcomment != null && d.internalcomment.toLowerCase().trim().indexOf(filter) != -1;
      const foundEnddate = searchEndDate && d.enddate != null && d.enddate.toString().toLowerCase().indexOf(filter) != -1;
      const foundDaysToLive = searchDays && d.daystolive != null && d.daystolive.toString().trim().indexOf(filter) != -1;
      const foundTimeLimitedType = searchLicenseType && d.ipaddress != null && d.ipaddress.toLowerCase().trim().indexOf(filter) != -1;
      if (filter.length == 0 || foundAccountName || foundEnddate ||
        foundEnddate || foundDaysToLive || foundProductName || foundActivatedDate ||
        foundLicense || foundFingerprint || foundIPAddress || foundInternalComment ||
        foundTimeLimitedType) {
        return true;
      } else {
        return false;
      }
    }
    this.dataSource.filter = filter;
  }

  selectColumns() {
    this.columnManager.openSelectColumnsDialog(
      this.dialog, this.dataSource,
      () => this.applyFilter(),
      this.saveConfig, this.snackMsg, this.auth
    );
  }
}
